export class WorkspacePanelsMenuItemClickedUIMessage {
  /** targetPanelId (CR-20260924-001 F4b): with OPEN_OR_ACTIVATE_MENU_TYPE, the ONE existing panel to
   * activate; null = add a new panel of the type. */
  constructor(public itemId: string, public menuType: string, public originKey: string,
              public targetPanelId: string | null = null) {}
}

/**
 * CR-20260922-001: a deep-link menu type. itemId = the panel typeCode; the workspace named by
 * originKey activates the panel named by targetPanelId, or adds one of that type when it is null.
 * Published by the host on an Action Board "open subject" request.
 */
export const OPEN_OR_ACTIVATE_MENU_TYPE = 'open-or-activate';

/**
 * CR-20260924-001 F4b: before a deep link, the host asks every live workspace which panels of a type
 * it holds. The message bus is synchronous, so each workspace appends to `found` in place and the
 * host reads the answer right after publishing. The host then targets ONE panel: the active panel
 * of that kind in the layout tab on screen, else any active one, else the first found, else a new
 * one — never every panel of the kind.
 */
export const PANELS_PROBE_TOPIC = 'WorkspacePanelsProbeUIMessage';

export interface WorkspacePanelsProbe {
  typeCode: number;
  found: WorkspacePanelsProbeHit[];
}

export interface WorkspacePanelsProbeHit {
  workspaceId: string;
  layoutTabId: string;
  panelId: string;
  /** The active tab of its workspace. */
  isActive: boolean;
}
